import React, { useEffect, useRef } from 'react';

// @context TGW-1769 リアクションピッカー。BEの MessagesLikeUser::AVAILABLE_LIKE_TYPES に
//   固定5種で対応する（任意絵文字はBE非対応のため対象外）。
const LIKE_TYPES = ['♥️', '😄', '🙁', '😢', '👍'];

export default function ReactionPicker({ onPick, onClose }) {
  const ref = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) onClose();
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  return (
    <div className="slackch-reaction-picker" ref={ref}>
      {LIKE_TYPES.map((type) => (
        <button key={type} type="button" onClick={() => onPick(type)}>
          {type}
        </button>
      ))}
    </div>
  );
}
